import { motion } from 'framer-motion';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="min-h-screen flex items-center justify-center px-6 lg:px-12 pt-20"
    >
      <div className="max-w-7xl mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: 'easeOut' }}
          className="text-center"
        >
          <motion.h1
            className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-light tracking-tight mb-8 lg:mb-12"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.2 }}
          >
            Creative
            <br />
            Studio
          </motion.h1>

          <motion.p
            className="text-lg sm:text-xl lg:text-2xl text-zinc-600 font-light max-w-3xl mx-auto mb-12 lg:mb-16 leading-relaxed"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.6 }}
          >
            혁신적인 디지털 경험을 창조합니다
            <br />
            브랜드의 가치를 극대화하는 크리에이티브 솔루션
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <button
              onClick={scrollToContact}
              className="w-full sm:w-auto bg-zinc-900 text-white px-10 py-4 text-sm uppercase tracking-wider hover:bg-zinc-800 transition-all cursor-pointer whitespace-nowrap"
            >
              Start Project
            </button>
            <button
              onClick={() => {
                const element = document.getElementById('work');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full sm:w-auto border border-zinc-900 text-zinc-900 px-10 py-4 text-sm uppercase tracking-wider hover:bg-zinc-900 hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              View Work
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
